import { render, staticRenderFns } from "./navbox.vue?vue&type=template&id=8502d822&scoped=true&"
import script from "./navbox.vue?vue&type=script&lang=js&"
export * from "./navbox.vue?vue&type=script&lang=js&"
import style0 from "./navbox.vue?vue&type=style&index=0&id=8502d822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8502d822",
  null
  
)

export default component.exports